let _currentUserId = null;

export function setSocketUser(user) {
    _currentUserId = user?.user_id ?? user?.id ?? null;
}

const createSocketService = () => {
  let socket = null;
  let notificationHandlers = new Set();
  let reminderHandlers = new Set();

  const connect = () => {
    if (socket) {
      return;
    }

    try {
      const userId = _currentUserId;

      // socket = io(`${process.env.REACT_APP_BASE_URL}`, {
      //   reconnection: false,
      //   auth: {
      //     token: token
      //   }
      // });

      socket.on('connect', () => {
        socket.emit('setUserId', userId);
      });

      socket.on('disconnect', () => {
      });

      socket.on('error', (error) => {
        console.error('WebSocket error:', error);
      });

      socket.on('notification', (data) => {
        notificationHandlers.forEach(handler => handler(data));
      });

      socket.on('reminder', (data) => {
        const reminderData = {
          message: data.message || 'Reminder notification',
          timestamp: new Date().toLocaleString(),
          type: 'reminder',
          details: data.details || {},
          priority: data.priority || 'normal'
        };
        reminderHandlers.forEach(handler => handler(reminderData));
      });

      socket.on('reminderStatus', (data) => {
        reminderHandlers.forEach(handler => handler({
          ...data,
          type: 'reminderStatus'
        }));
      });

    } catch (error) {
      console.error('Error connecting to WebSocket:', error);
    }
  };

  const disconnect = () => {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
  };

  const addNotificationHandler = (handler) => {
    notificationHandlers.add(handler);
  };

  const removeNotificationHandler = (handler) => {
    notificationHandlers.delete(handler);
  };

  const addReminderHandler = (handler) => {
    reminderHandlers.add(handler);
  };

  const removeReminderHandler = (handler) => {
    reminderHandlers.delete(handler);
  };

  const acknowledgeReminder = (reminderId) => {
    if (socket) {
      socket.emit('acknowledgeReminder', { reminderId });
    }
  };

  const dismissReminder = (reminderId) => {
    if (socket) {
      socket.emit('dismissReminder', { reminderId });
    }
  };

  return {
    connect,
    disconnect,
    addNotificationHandler,
    removeNotificationHandler,
    addReminderHandler,
    removeReminderHandler,
    acknowledgeReminder,
    dismissReminder
  };
};

export const socketService = createSocketService();